import axios from 'axios';
import oidcManager from '../services/auth/oidc-manager';
import { handleNetworkError, handleF5Block } from './interceptors/errors';

/* Returns a new Axios instance configuired for the project
 * @param {string} apiVersion - if you'd like to use version 2 of the API pass 'v2'.  Defaults to what is specified in the globalConfig.
 * @param {number} timeout - how many milliseconds you'd like Axios to wait before reporting a timeout error.  Defaults to 0 (or not specified).  This setting has no effect on the server's timeout limit.
 */
const apiClient = (apiVersion, timeout = 0) => {
	// Use the api version specified in globalConfig unless a version is passed
	let version = apiVersion
		? apiVersion
		: globalConfig.api.version.replace(/^\//, '').replace(/\/$/, '');

	const axiosClient = axios.create({
		baseURL: `${globalConfig.api.endpoint_uri.replace(/\/$/, '')}/${version}`,
		withCredentials: false,
		timeout,
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
		},
	});

	axiosClient.interceptors.request.use(
		async (config) => {
			const accessToken = await oidcManager
				.getUser()
				.then((user) => user && user.access_token);
			config.headers.authorization = `Bearer ${accessToken}`;
			return config;
		},
		(error) => Promise.reject(error),
	);

	axiosClient.interceptors.response.use(
		(response) => response,
		(error) => {
			handleNetworkError(error);
			handleF5Block(error);
			return error;
		},
		{ synchronous: true },
	);

	return axiosClient;
};

export const cancelController = () => {
	const controller = new AbortController();
	return controller;
};

export default apiClient;
